var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpressTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322,
    cy: 238,
    rx: 158,
    ry: 159,
    fill: "#F0FFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.977 161.156H382.965V175.761H337.313C337.313 175.761 351.828 190.952 351.828 200.885H382.832V214.321H353.146C353.146 214.321 347.208 259.657 290.343 256.853L359.744 330.819H332.037L261.977 259.426V244.469C261.977 244.469 296.413 245.402 312.905 235.471C326.23 227.409 324.515 222.501 325.702 217.826C326.1 216.074 324.646 214.439 322.667 214.439H261.977V201.001H324.121C325.438 201.001 326.23 199.831 325.572 198.78C322.931 194.224 315.94 184.057 306.309 182.189C293.773 179.853 261.977 179.267 261.977 179.267V161.156Z",
    fill: "#231942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 152H243",
    stroke: "#F0FFF1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134 339H206",
    stroke: "#F0FFF1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59 210H193",
    stroke: "#F0FFF1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88 273H192",
    stroke: "#F0FFF1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 273H53",
    stroke: "#F0FFF1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38 152H75",
    stroke: "#F0FFF1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34 339L112 339",
    stroke: "#F0FFF1",
    strokeWidth: 19.9406,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressTransfer);
export default __webpack_public_path__ + "static/media/express_transfer.0b348411a604c846816375f71144f369.svg";
export { ForwardRef as ReactComponent };